import type { FormFieldConfig, FormSectionConfig, FieldRenderContext } from './types'

export const buildInitialForm = <T = Record<string, unknown>>(sections: FormSectionConfig[]): T => {
    const result: Record<string, unknown> = {}
    for (const section of sections) {
        for (const field of section.fields) {
            result[field.key] = field.defaultValue ?? (field.type === 'checkbox' ? false : '')
        }
    }
    return result as T
}

export const groupFieldsByRow = (fields: FormFieldConfig[]): FormFieldConfig[][] => {
    const rowMap = new Map<number, FormFieldConfig[]>()
    for (const f of fields) {
        const arr = rowMap.get(f.row) ?? []
        arr.push(f)
        rowMap.set(f.row, arr)
    }
    return Array.from(rowMap.values())
}

export const getFieldTestId = (ctx: Pick<FieldRenderContext, 'testIdPrefix'>, key: string, suffix: string) =>
    `${ctx.testIdPrefix ?? 'checkout-field'}-${key.replace(/_/g, '-')}-${suffix}`

// Checks ctx props that every field type cares about. Per-type comparators
// (attached to each renderer as `areCtxEqual`) run afterward for the type-
// specific slice. Splitting keeps each renderer's concerns in its own file.
export const commonCtxEqual = (field: FormFieldConfig, a: FieldRenderContext, b: FieldRenderContext): boolean => {
    const k = field.key
    if (a.form[k] !== b.form[k]) return false
    if (a.errors?.[k] !== b.errors?.[k]) return false
    if (a.errorKeyPrefix !== b.errorKeyPrefix) return false
    if (a.testIdPrefix !== b.testIdPrefix) return false
    if (a.formDisabled !== b.formDisabled) return false
    if (a.set !== b.set) return false
    if (a.setForm !== b.setForm) return false
    return true
}
